import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Progress,
  Text,
} from "@chakra-ui/react";

const MatchResultTable = ({ candidates = [] }) => {
  if (!candidates.length) {
    return <Text color="gray.500">No matches found.</Text>;
  }

  return (
    <Table size="sm">
      <Thead>
        <Tr>
          <Th>Candidate</Th>
          <Th>Match Score</Th>
          <Th>Skill Match</Th>
          <Th>Experience Match</Th>
          <Th>Location Match</Th>
        </Tr>
      </Thead>
      <Tbody>
        {candidates.map((item) => (
          <Tr key={item.resumeId}>
            <Td>
              {item.candidate?.fullName ||
                item.candidate?.firstName ||
                "Candidate"}
            </Td>
            <Td>
              <Progress
                value={item.matchScore || 0}
                size="sm"
                borderRadius="md"
              />
              <Text fontSize="xs">{item.matchScore || 0}%</Text>
            </Td>
            <Td>{item.skillMatch || 0}%</Td>
            <Td>{item.experienceMatch || 0}%</Td>
            <Td>{item.locationMatch || 0}%</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default MatchResultTable;
